import { Box, Heading, Icon, Text, Grid } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { BiCalendarHeart } from "react-icons/bi";
import { FaUser } from "react-icons/fa";
import { IoMdHeart } from "react-icons/io";
import { MdPeople } from "react-icons/md";
import {BaseUrl} from "../../../const.ts";
import axios from "axios";

const EventCountSection = () => {
  const { t } = useTranslation();
  const [counts, setCounts] = useState({
    events: 0,
    online: 0,
    inPerson: 0,
    users: 0,
  });

  useEffect(() => {
    axios
        .get(`${BaseUrl}/events-ms/premium-events/counts`)
        .then((res) => {
          const data = res.data?.body;
          setCounts(data);
        })
        .catch((e) => console.log(e));
  }, []);

  return (
      <Box
          position="relative"
          w="100%"
          bg="#111833"
          p={{ base: "80px 20px", md: "120px 0px" }}
          mb="100px"
          textAlign="center"
          color="#ffffff"
      >
        <Grid
            w={{ base: "100%", md: "80%" }}
            mx="auto"
            templateColumns="repeat(4, 1fr)"
            gap="40px"
            alignItems="center"
        >
          <CountIcon
              icon={BiCalendarHeart}
              count={counts.events}
              label={t("Events")}
              duration={5.75}
          />
          <CountIcon
              icon={FaUser}
              count={counts.online}
              label={t("Online Events")}
              duration={6.75}
          />
          <CountIcon
              icon={IoMdHeart}
              count={counts.inPerson}
              label={t("Person Events")}
              duration={7.75}
          />
          <CountIcon
              icon={MdPeople}
              count={counts.users}
              label={t("Users")}
              duration={8.75}
          />
        </Grid>
      </Box>
  );
};

export default EventCountSection;

const CountIcon = ({ icon, count, label, duration }) => {
  const [displayCount, setDisplayCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const increment = Math.ceil(count / (duration * 60));
    const interval = setInterval(() => {
      start += increment;
      setDisplayCount(Math.min(start, count));
      if (start >= count) clearInterval(interval);
    }, 16);
    return () => clearInterval(interval);
  }, [count, duration]);

  return (
      <Box
          className="wow fadeInUp"
          data-wow-delay="200ms"
          data-wow-duration="1500ms"
          textAlign="center"
          transition="transform 0.3s ease-in-out"
          _hover={{ transform: "scale(1.05)" }}
          p="20px"
          w="100%"
          bg="rgba(255, 255, 255, 0.1)"
          borderRadius="md"
          boxShadow="0px 10px 25px rgba(0, 0, 0, 0.1)"
      >
        <Icon as={icon} boxSize={12} mb={4} />
        <Heading fontSize={{ base: "4xl", md: "5xl" }} fontWeight="bold" color="white">
          {displayCount}
        </Heading>
        <Text fontSize={{ base: "xl", md: "2xl" }} fontWeight="medium" mt={2}>
          {label}
        </Text>
      </Box>
  );
};
